const standardizePhoneNumber = (phoneNumber, countryDialingCode) => {
  let cleanedPhoneNumber = phoneNumber.replace(/\D/g, "");
  if (cleanedPhoneNumber[0] === "0" && !!countryDialingCode) {
    const keepLeadingZero = shouldKeepLeadingZero(cleanedPhoneNumber, countryDialingCode);
    cleanedPhoneNumber = String(countryDialingCode) + (keepLeadingZero ? cleanedPhoneNumber : cleanedPhoneNumber.slice(1));
  }
  if (cleanedPhoneNumber[0] !== "+") {
    cleanedPhoneNumber = "+" + cleanedPhoneNumber;
  }
  return cleanedPhoneNumber;
};
const localizePhoneNumber = (standardizedPhoneNumber, countryDialingCode) => {
  const standardizeDialingCode = String(countryDialingCode).replace("+", "");
  let cleanedPhoneNumber = standardizedPhoneNumber;
  if (cleanedPhoneNumber[0] === "+") {
    const isStartWithZero = cleanedPhoneNumber[standardizeDialingCode.length + 1] === "0";
    cleanedPhoneNumber = cleanedPhoneNumber.replace("+" + standardizeDialingCode, isStartWithZero ? "" : "0");
  }
  return cleanedPhoneNumber;
};
const PHONE_KEEPING_ZERO = {
  // Indonesia
  "62": [11]
  // Keep leading zero if the phone number length is 11
};
const shouldKeepLeadingZero = (phoneNumber, countryDialingCode) => {
  var _a;
  const standardizeDialingCode = String(countryDialingCode).replace("+", "");
  const phoneLength = phoneNumber.length;
  const keepLeadingZero = (_a = PHONE_KEEPING_ZERO[standardizeDialingCode]) == null ? void 0 : _a.includes(phoneLength);
  return keepLeadingZero ?? false;
};
export {
  localizePhoneNumber,
  standardizePhoneNumber
};
